import { createPortal } from 'react-dom'

import ModalFrame, { ModalFrameProps } from './ModalFrame'
import { modalRoot } from './modalRoot'

const stackedModalDefaultProps = {
    isVisible: true,
}

/**
 * ### Modal will capture focus
 *
 * The first element may be the close button. In order to manually set the focus element,
 * provide `data-autofocus` on the prop you want focus on.
 *
 * ### Using the modal with our without the stack (`useModal`)
 *
 * - If you are using `useModal` then you want to set the `stack`, like: `<Modal stack>...`.
 * - If you are using `Modal` directly, then leave the `stack` property out.
 */
const Modal = ({ stack, ...otherProps }: ModalFrameProps) => {
    const modalFrameProps = stack
        ? { ...otherProps, ...stackedModalDefaultProps }
        : otherProps

    return stack !== true ? (
        createPortal(<ModalFrame {...modalFrameProps} />, modalRoot())
    ) : (
        <ModalFrame {...modalFrameProps} />
    )
}

export default Modal
